<template>
    <div class="bg-[#23242A] custom">
        <div class="flex xl:flex-row flex-col px-4 pt-4 gap-4 bg-[#23242A] text-white">
            <div :class="(add || edit)?'xl:w-[50%]':'w-full'" class="custom-left">
                <div class="rounded-[10px] pb-2 bg-[#2B2C32] w-full">
                    <div class="text-[24px] font-semibold text-white px-4 pt-4">
                        <div class="flex justify-between">
                            <span>Employee List</span>
                            <div>
                                <input type="text" v-model="search" @keydown="searchData" class="rounded bg-field-black align-top mr-2 border-0" placeholder="Search..." />
                                <button  v-if="can_manage_employees" class="text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer" @click.prevent="openAdd">
                                    <span>
                                        <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table w-full mt-6 pb-4">
                        <block-loading v-if="loading" />
                        <table-lite
                            v-else
                            :is-slot-mode="true"
                            :has-checkbox="false"
                            :class="'block w-full admin-table admin-table-custom'"
                            :rowClasses="row => row?row.id:null"
                            :columns="table.columns"
                            :rows="table.rows"
                            :total="table.totalRecords"
                            :sortable="table.sortable"
                            :page-size="table.pagesize"
                            @do-search="doSearch"
                            :page="table.page"
                            
                            @row-clicked="selectedRow"
                            :pageOptions='table.pageOptions'
                            :messages="{
                                pagingInfo: 'Total: {2}',
                                pageSizeChangeLabel: 'Items per Page',
                                gotoPageLabel: 'Go to page',
                                noDataAvailable: 'No records found!',
                            }"
                        >
                            <template v-slot:role="data">
                                <span v-if="data?.value?.roles?.length>0">{{data.value.roles[0]}}</span>
                            </template>
                        </table-lite>

                    </div>
                </div>
            </div>
            <div v-if="add || edit" class="xl:w-[50%] w-full custom-right pb-12">
                <add-employee v-if="add" @added="closeAddAndGetData" @close="closeAdd" />
                <edit-employee v-if="edit" :editItem="editItem" @edited="edited" @close="closeEdit" />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, reactive, ref, createApp, h, SetupContext} from "vue";
import AddEmployee from './AddEmployee.vue'
import EditEmployee from './EditEmployee.vue'
import EmployeeApi from "@/controllers/EmployeeApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import debounce from 'lodash/debounce'
import Env from '@/env'

export default defineComponent({
    components: {
        AddEmployee,
        EditEmployee
    },
    setup(){
        const snackbar = useSnackbar();
        const loading = ref(false);
        // search
        let search = ref('')

        // list
        const table:any = reactive({
          loading: true,
          columns: [
            {label: 'Name', field:'name', sortable: true, isKey: true, checkbox: true },
            {label: 'Email', field:'email', sortable: true},
            {label: 'Role', field:'role', sortable: true},
            // {label: 'Location', field:'location', sortable: true},
          ],
          rows: [],
          totalRecords: 0,
          page: 1,
          sortable: {
            order: "",
            sort: "",
          },
           pagesize: Env.defaultPageSize,
           pageOptions: Env.pageList,
           count: 0,
        })

        // add
        const add = ref(false)

        //edit
        const edit = ref(false)
        const editItem = ref<any>()

        return {snackbar, loading, search, table, add, edit, editItem}
    },

    computed: {
        
        can_manage_employees() {
            return Helpers.getMyPermission('can_manage_employees');
        },

    },

    mounted(){
        this.add = false
        this.edit = false
        this.getData()
    },
    methods: {
        async doSearch(offset, limit, order, sort){             
            this.loading =true
            let sorting = (sort)?sort:'asc'
            let page = (offset/limit)+1
            this.table.page = page
            let params = `page=${page}&perPage=${limit}&sortByName=${sorting}&includeRoles=1`
            if(this.search){
                params+=`&search=${this.search}`
            }
            let {data: {payload}} = await EmployeeApi.getAllUsers(params)
            this.table.rows = payload.data
            this.table.totalRecords = payload.totalRecords;
            this.table.pagesize = payload.perPage
            this.table.sortable.order = ''
            this.table.sortable.sort = ''
            this.loading = false
        },
        selectedRow(item){
            // reject if no permission
            if(!this.can_manage_employees) return;

            // selection effect
             let activeRow = document.getElementsByClassName(item.id);
             if(activeRow[0] && activeRow[0].parentNode && activeRow[0].parentNode.children){
                for(let sibling of activeRow[0].parentNode.children){
                    sibling.classList.remove('active-row')
                }
             }
             activeRow[0].classList.add("active-row")

            // action
            this.add = false
            this.edit = true
            this.editItem = item
        },
        async getData(page='', perPage='', sorting='', search=''){
            this.loading =true
            let params = ''
            if(page){
                params = 'page='+page+'&'; 
            }else {
                params = 'page=1&'
            }
            this.table.page = page;

            if(perPage){
                params += `perPage=${perPage}&`
            }else{
                params += `perPage=${Env.defaultPageSize}&`
            }

            if(sorting){
                params += `sortByName=${sorting}&`
            }else{
                params += `sortByName=asc&`
            }

            if(search){
                params += `search=${search}&`
            }
            params += 'includeRoles=1'

            let res = await EmployeeApi.getAllUsers(params)
            if(res.data && res.data.payload){
                let payload = res.data.payload
                this.table.rows = payload.data
                this.table.totalRecords = payload.totalRecords
                this.table.pagesize = payload.perPage
                this.loading =false
            }else{
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                this.loading = false
            }
        },
        openAdd(){
            this.edit = false
            this.add = true
        },
        closeAdd(){
            this.add = false
        },
        closeAddAndGetData(){
            this.add = false
            this.getData(this.table.page, this.table.pagesize, '', this.search)
        },
        edited(){
            this.closeEdit()
            this.getData(this.table.page, this.table.pagesize, '', this.search)
        },
        closeEdit(){
            this.edit = false
        },
        searchData: debounce(function(this:any){
            if(this.search.length>=3 || this.search==''){
                this.getData('','','',this.search)
            }
        }, 400),
    }
})
</script>